import { render, staticRenderFns } from "./listado.vue?vue&type=template&id=0152c0dc"
import script from "./listado.vue?vue&type=script&lang=js"
export * from "./listado.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports